<div class="busy-container" *ngIf="show">
  <div class="busy-background"></div>
  <div class="busy-spinner-container">
    <div class="spinner-border">

    </div>
  </div>
</div>
